import React from 'react';
import { Modal } from 'react-bootstrap';
import { ImageSecurityAlert } from '../../assets/images';
import { TranslationUtils, ValidationUtils } from '../../utils';
import './UnavailableModal.scss';
import { useSelector } from 'react-redux';
import { StoreState } from '../../types/store.type';

export const UnavailableModal: React.FC = (props) => {
    const { unit } = useSelector((store: StoreState) => store.trip);
    const isShowing = ValidationUtils.validateAndGetEnvVar('REACT_APP_PORTAL_UNAVAILABLE') === 'true';
    const vacasaUrl = ValidationUtils.validateAndGetEnvVar('REACT_APP_VACASA_URI');
    let localPhoneNumber = ValidationUtils.validateAndGetEnvVar('REACT_APP_TOLL_FREE_PHONE_NUMBER');

    if (unit && unit.local_phone_number) {
        localPhoneNumber = unit.local_phone_number;
    }

    const handleClose = () => {
        window.location.replace(`${vacasaUrl}/my-trips`);
    };

    const blurEverything = () => {
        const app = document.getElementById('routed-app');
        if (app) {
            app.setAttribute('class', 'blur');
        }
    };

    return (
        <Modal id="unavailable-modal" show={isShowing} onEnter={blurEverything} onHide={handleClose}>
            <Modal.Header closeButton />

            <div className="idv-modal-body">
                <div>
                    <ImageSecurityAlert className="unavailable-modal-image" />
                </div>
                <h5 className={'heading-med-light'}>{TranslationUtils.get('guest_portal_unavailable')}</h5>

                <div className="unavailable-instructions">
                    <p className={'body-regular'}>
                        {TranslationUtils.get('resolve_issues_calling')} [
                        <span>
                            <a href={`tel:${localPhoneNumber}`}>{localPhoneNumber}</a>
                        </span>
                        ]
                    </p>
                </div>
            </div>
        </Modal>
    );
};
